import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import themeColors from '../../utils/contants/theme-colors';

const fieldsPiani = (
  handleCopiaPianoConsolidato,
) => (
  [
    {
      dataField: 'desc_denominazione',
      text: 'Titolo Piano',
      classes: 'column-data',
      headerStyle: () => ({ width: '80%' }),
    },
    {
      dataField: 'df1',
      text: 'Azioni',
      style: { verticalAlign: 'middle' },
      headerStyle: () => ({ width: '20%' }),
      formatter: (e, row) => (
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <FontAwesomeIcon
            aria-hidden="true"
            icon="fa-solid fa-copy"
            size="lg"
            title="Copia da questo piano"
            style={{ color: themeColors.primary }}
            onClick={() => handleCopiaPianoConsolidato(row)}
          />
        </div>
      ),
    },
  ]
);

export default fieldsPiani;
